import Card from '@/components/ui/Card'
import { cn } from '@/lib/utils'
import type { NonCoveredItem } from '@/types/cost'

interface NonCoveredItemsProps {
  /** 비급여 항목 목록 */
  items: NonCoveredItem[]
  /** 추가 CSS 클래스 */
  className?: string
}

/** 금액을 만원 단위로 포맷 */
function formatManWon(amount: number): string {
  const man = Math.round(amount / 10000)
  return `약 ${man.toLocaleString()}만원`
}

/**
 * 비급여 항목 상세 목록.
 *
 * - 식재료비, 간식비, 이미용비, 프로그램비, 소모품비, 관리비 등
 * - 항목별 예상 금액 표시
 */
export default function NonCoveredItems({
  items,
  className,
}: NonCoveredItemsProps) {
  if (items.length === 0) return null

  return (
    <Card className={cn('', className)}>
      <h3 className="text-body font-bold text-cb-gray-900 mb-4">
        비급여 항목 상세
      </h3>

      <div className="flex flex-col gap-2.5">
        {items.map((item) => (
          <div
            key={item.name}
            className="flex items-center justify-between"
          >
            <div className="flex flex-col">
              <span className="text-body text-cb-gray-600">{item.name}</span>
              {item.description && (
                <span className="text-caption text-cb-gray-400">
                  {item.description}
                </span>
              )}
            </div>
            <span className="text-body font-medium text-cb-gray-900 flex-shrink-0 ml-4">
              {formatManWon(item.monthlyAverage)}
            </span>
          </div>
        ))}
      </div>
    </Card>
  )
}
